import {
  THERAPIST_DIRECT_SESSION,
  THERAPIST_DIRECT_VALIDATION_USER,
  THERAPIST_DIRECT_USER_ACCOUNT,
} from "../../config";
import type { AccountSession, SignedInUser } from "../types/auth";

// Helper function to safely parse JSON
function safeJsonParse<T>(value: string | null): T | null {
  try {
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error("Failed to parse JSON:", error);
    return null;
  }
}

// Validation User Functions
export function setValidationUser(username: string): void {
  sessionStorage.setItem(THERAPIST_DIRECT_VALIDATION_USER, username);
}

export function getValidationUser(): string | null {
  return sessionStorage.getItem(THERAPIST_DIRECT_VALIDATION_USER);
}

export function removeValidationUser(): void {
  sessionStorage.removeItem(THERAPIST_DIRECT_VALIDATION_USER);
  localStorage.removeItem(THERAPIST_DIRECT_USER_ACCOUNT);
  localStorage.removeItem(THERAPIST_DIRECT_SESSION);
}

// Account Session Functions
export function setAccountSession(session: AccountSession): void {
  localStorage.setItem(THERAPIST_DIRECT_SESSION, JSON.stringify(session));
}

export function getAccountSession(): AccountSession | null {
  const session = localStorage.getItem(THERAPIST_DIRECT_SESSION);
  return safeJsonParse<AccountSession>(session);
}

export function getAccessToken(): string | null {
  const session = getAccountSession();
  return session?.token || null;
}

// User Account Functions
export function setUserAccount(account: SignedInUser): void {
  localStorage.setItem(THERAPIST_DIRECT_USER_ACCOUNT, JSON.stringify(account));
}

export function getUserAccount(): SignedInUser | null {
  const account = localStorage.getItem(THERAPIST_DIRECT_USER_ACCOUNT);
  return safeJsonParse<SignedInUser>(account);
}

// Logout Function
export function logout(): void {
  removeValidationUser();
  window.location.href = "/login"; // Redirect to login page after logout
}